import { MapStorePlugin } from "./types";

export const registeredPlugins: MapStorePlugin<any>[] = [];

export const registerPlugin = (component: MapStorePlugin<any>) => {
    console.log("Registering component", component);
    registeredPlugins.push(component);
};
